import {useState,type FormEvent} from "react";
import {ProductWordmark} from "./ProductWordmark";

type LoginPageProps={
  onSubmit:(username:string,password:string)=>void|Promise<void>;
  pending?:boolean;
  errorMessage?:string;
  brandLogo?:{src:string;alt:string};
  demoCredentials?:{username:string;password:string};
  introductionAudio?:{title:string;src:string};
};

export function LoginPage({
  onSubmit,
  pending=false,
  errorMessage,
  brandLogo,
  demoCredentials,
  introductionAudio,
}:LoginPageProps){
  const[username,setUsername]=useState("");
  const[password,setPassword]=useState("");
  const submit=(event:FormEvent)=>{
    event.preventDefault();
    onSubmit(username.trim(),password);
  };

  return <main className="login-page">
    <div className="login-stack">
      <section className="login-card" aria-labelledby="login-title">
        <header>
          {brandLogo?<img className="login-brand-logo" src={brandLogo.src} alt={brandLogo.alt}/>:null}
          <div>
            <ProductWordmark version="V03"/>
            <p>Gestione asset, manutenzione e integrità impiantistica</p>
          </div>
        </header>
        <form onSubmit={submit}>
          <h1 id="login-title">Accesso alla piattaforma</h1>
          <label><span>Nome utente</span><input autoComplete="username" required value={username} onChange={event=>setUsername(event.target.value)}/></label>
          <label><span>Password</span><input type="password" autoComplete="current-password" required value={password} onChange={event=>setPassword(event.target.value)}/></label>
          <button type="submit" disabled={pending}>{pending?"Accesso in corso…":"Accedi"}</button>
          {demoCredentials?<aside className="login-demo-credentials" aria-label="Credenziali per la demo">
            <strong>Credenziali per la demo</strong>
            <dl>
              <div><dt>Login</dt><dd><code>{demoCredentials.username}</code></dd></div>
              <div><dt>Password</dt><dd><code>{demoCredentials.password}</code></dd></div>
            </dl>
          </aside>:null}
          {errorMessage?<p role="alert">{errorMessage}</p>:null}
        </form>
      </section>
      {introductionAudio?<section className="login-introduction-audio" aria-labelledby="login-audio-title">
        <h2 id="login-audio-title">{introductionAudio.title}</h2>
        <audio controls preload="metadata" src={introductionAudio.src}>Il browser non supporta la riproduzione audio.</audio>
      </section>:null}
    </div>
  </main>;
}
